import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { fleetPageBreadcrumbs } from '../config/breadcrumbs';
import { GlobalButton, NavigateLinks, BackToModuleButton } from '@/components';
import { CompanyTable, SearchBar, ConfirmDeleteCompanyModal } from './components';
import { useMemo, useState, useEffect } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import styles from '../FleetPages.module.css';
import { useQueryParams } from '@/hooks';
import useDeleteCompanyModal from './hooks/useDeleteCompanyModal';

const Companies = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => fleetPageBreadcrumbs(navigate), [navigate]);
  const {
    deleteModal,
    openDeleteModal,
    closeDeleteModal,
    handleConfirmDelete,
    isDeleting,
  } = useDeleteCompanyModal();

  const { getQueryParam, setQueryParams } = useQueryParams();
  const [companySearch, setCompanySearch] = useState(getQueryParam('search') || '');

  useEffect(() => {
    setQueryParams({ search: companySearch });
  }, [companySearch, setQueryParams]);

  return (
    <section className={styles.container}>
      <NavigateLinks actualPage="Compañías" breadcrumbs={breadcrumbs} />

      <div className={styles.actions}>
        <BackToModuleButton breadcrumbs={breadcrumbs} />

        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('new')}
        >
          <AddIcon />
          Agregar compañía
        </GlobalButton>
      </div>

      <SearchBar searchValue={companySearch} onSearch={setCompanySearch} />

      <div className={styles.content}>
        <CompanyTable
          search={companySearch}
          onDeleteCompany={openDeleteModal}
        />
      </div>

      <ConfirmDeleteCompanyModal
        open={deleteModal.open}
        companyName={deleteModal.companyName}
        isLoading={isDeleting}
        onClose={closeDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </section>
  );
};

export default Companies;
